import { useQuery } from '@tcs/common/hooks/useQuery';
import { Document } from '@tcs/client-portal-api/types/Documents';
import { DocumentType } from '@tcs/client-portal-api/platform_generated';

interface Props {
  loading: boolean;
  data: Document[];
}

export const useDocuments = (
  accountNumber: string,
  type: DocumentType,
  year?: string
): Props => {
  let path = `/documents/account/${accountNumber}?type=${type}`;
  if (year) {
    path += `&year=${year}`;
  }
  const { data, isLoading: loading } = useQuery<[Document], Error>(path, {
    refetchOnMount: false,
    enabled: accountNumber !== undefined,
  });

  // Sort documents by year in descending order (latest year first)
  const sortedData = data
    ? [...data].sort((a, b) => {
        return parseInt(b.year) - parseInt(a.year);
      })
    : data;

  return {
    loading,
    data: sortedData,
  };
};

export default useDocuments;
